module.exports = __webpack_public_path__ + "static/media/bot_icon1.a936b939.png";